class ProductCapture {
  constructor() {
    this.setRecentlyViewedProducts();
  }

  setRecentlyViewedProducts() {
    const productData = {
      url: window.productStrings.url,
      handle: window.productStrings.handle
    };

    if (productData.handle) {
      const productList = [];
      const limit = 30;
      const storedProducts = localStorage.getItem("recentlyViewedProducts");

      productList.push(productData);

      // Adds or removes product history from local storage

      if (storedProducts === null) {
        // 1st product added
        localStorage.setItem("recentlyViewedProducts", JSON.stringify(productList));
      } else if (storedProducts) {
        // 2nd, 3rd, 4th products added
        const storedProductsLength = (JSON.parse(storedProducts) || []).length;
        const duplicate = storedProducts.includes(productData.handle);

        if (storedProductsLength < limit && !duplicate) {
          const products = JSON.stringify(JSON.parse(storedProducts).concat(productList));

          localStorage.setItem("recentlyViewedProducts", products);
        } else if (storedProductsLength >= limit && !duplicate) {
          // 5th products added
          const updatedProducts = JSON.parse(storedProducts);

          updatedProducts.shift();
          updatedProducts.push(productData);

          const products = JSON.stringify(updatedProducts);
          localStorage.setItem("recentlyViewedProducts", products);
        }
      }
    }
  }
}

new ProductCapture();